import { useState, useEffect, useCallback } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Col,
  Row,
  Flex,
  notification,
  Radio,
  Space,
} from "antd";
import cargarDeptosMunicipios from "../../../services/departMunic/deptosMunicipiosServices";
import {
  getAllOrganizacionesSostenibilidad,
  getAllProyectosxOrganizacionesSostenibilidad,
} from "../../../services/sostenibilidad/organizaciones/organizacionesSostenibilidadservices";
import {
  getAllEnfoqueEtnia,
  insertParticipanteSostenibilidad,
} from "../../../services/sostenibilidad/participantesSostenibilidad";

const { Option } = Select;

const ParticipanteForm = ({ form, onClose, fetchData, initialData }) => {
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [organizaciones, setOrganizaciones] = useState([]);
  const [departamentosxmunicipio, setDepartamentosxmunicipio] = useState([]);
  const [proyectosxOrganizacion, setProyectosxOrganizacion] = useState([]);
  const [enfoquesEtnia, setEnfoquesEtnia] = useState([]);

  const [municipioSeleccionado, setMunicipioSeleccionado] = useState(null);
  const [departamentoSeleccionado, setDepartamentoSeleccionado] =
    useState(null);
  const [organizacionSeleccionada, setOrganizacionSeleccionada] =
    useState(null);
  const [proyectoSeleccionado, setProyectoSeleccionado] = useState(null);

  const [enfoquesEtnicos, setEnfoquesEtnicos] = useState([]);
  const [tieneDiscapacidad, setTieneDiscapacidad] = useState(false);
  const [mostrarInputOtro, setMostrarInputOtro] = useState(false);
  const [tipoDiscapacidad, setTipoDiscapacidad] = useState("");
  const [tipoParticipante, setTipoParticipante] = useState("");

  const tiposDiscapacidad = [
    { value: "Física", label: "Física" },
    { value: "Sensorial", label: "Auditiva" },
    { value: "Intelectual", label: "Motriz" },
    { value: "Psicosocial", label: "Intelectual" },
    { value: "Orgáinica", label: "Psicosocial" },
    { value: "Otro", label: "Otro" },
  ];

  const handleChangeTipo = (value) => {
    if (value === "Otro") {
      setMostrarInputOtro(true);
      setTipoDiscapacidad(""); // Resetear el valor previo
    } else {
      setMostrarInputOtro(false);
      setTipoDiscapacidad(value);
    }
  };

  const eliminarOtro = () => {
    setMostrarInputOtro(false);
    setTipoDiscapacidad("");
  };

  // 1. Cargar datos iniciales
  useEffect(() => {
    obtenerdepartamentos();
    obtenerOrganizaciones();
    obtenerEnfoqueEtnia();
  }, []);

  useEffect(() => {
    const setInitialValues = async () => {
      if (initialData && Object.keys(initialData).length > 0) {
        form.resetFields();
        form.setFieldsValue(initialData);

        if (initialData?.id_organizacion) {
          setOrganizacionSeleccionada(initialData.id_organizacion);
        }

        if (initialData?.id_proyecto && proyectosxOrganizacion.length > 0) {
          setProyectoSeleccionado(initialData.id_proyecto);
        }

        if (initialData?.departamento) {
          // Esperamos un breve momento para asegurar que departamentosxmunicipio esté cargado
          await new Promise((resolve) => setTimeout(resolve, 50));
          setDepartamentoSeleccionado(initialData.departamento);
          handleDepartamentoChange(initialData.departamento);
        }

        if (initialData?.tiposDiscapacidad) {
          setTieneDiscapacidad(initialData.tiposDiscapacidad);
        }
      }
    };

    setInitialValues();
  }, [initialData, form, departamentosxmunicipio]); // Añadimos departamentosxmunicipio a las dependencias

  const handleDepartamentoChange = useCallback(
    (valor) => {
      setMunicipios([]);
      form.setFieldsValue({ id_municipio: undefined });
      setDepartamentoSeleccionado(valor);

      if (!departamentosxmunicipio || departamentosxmunicipio.length === 0) {
        setMunicipios([]);
        return;
      }

      const lista_municipios = departamentosxmunicipio.find(
        (dep) => dep.nombre_departamento === valor
      );

      if (lista_municipios?.municipios) {
        const municipiosOrdenados = lista_municipios.municipios
          .map((mun) => ({
            id: mun.oid_municipio,
            nombre: mun.nombre_municipio,
          }))
          .sort((a, b) => a.nombre.localeCompare(b.nombre));

        setMunicipios(municipiosOrdenados);

        // Si hay un municipio en initialData y está en la lista cargada, lo seleccionamos
        if (
          initialData?.id_municipio &&
          municipiosOrdenados.some((m) => m.id === initialData.id_municipio)
        ) {
          form.setFieldsValue({ id_municipio: initialData.id_municipio });
        }
      } else {
        setMunicipios([]);
      }
    },
    [departamentosxmunicipio, form, initialData]
  );

  // 3. Obtener proyectos cuando se selecciona una organización
  useEffect(() => {
    if (organizacionSeleccionada) {
      obtenerProyectosxOrganizacion(organizacionSeleccionada);
    }
  }, [organizacionSeleccionada]);
  //maneja el cambio de estado del organización
  const handleOrganizacionChange = (valor) => {
    obtenerProyectosxOrganizacion(valor);

    setProyectosxOrganizacion([]);
    form.setFieldsValue({ id_proyecto: undefined });
    setOrganizacionSeleccionada(valor);
  };

  const onFinish = async (values) => {
    try {
      // Asignación segura, incluso si initialData es null/undefined
      values.codigo_interno_sostenibilidad = initialData?.codProyecto ?? null;

      if (values.tipo_discapacidad === "Otro") {
        values.tipo_discapacidad = values.discapacidadOtro;
      }
      const result = await insertParticipanteSostenibilidad(values);

      if (result.status) {
        notification.success({
          message: "Éxito",
          description: result.message,
        });

        fetchData({
          id: result.idRegistro, // suponiendo que insert devuelve el nuevo ID
          nombre_completo: values.nombre_completo,
          tipo_participante: values.tipo_participante,
          codigo_sirr: values.codigo_sirr,
        });
        onClose();
        form.resetFields();
      } else {
        notification.error({
          message: "Error",
          description: result.message || "No se pudo insertar el participante.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error inesperado",
        description: "Ocurrió un error al procesar la solicitud.",
      });
    }
  };

  const handleKeyDown = (e) => {
    // Permitir: teclas de control (Backspace, Delete, Tab, Flechas)
    if (
      [
        "Backspace",
        "Delete",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
      ].includes(e.key)
    ) {
      return; // Permitir estas teclas
    }

    // Bloquear si no es un número (0-9)
    if (!/^\d+$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    // Obtener el texto pegado
    const pastedText = e.clipboardData.getData("text/plain");
    // Si contiene algo que no sean números, cancelar el pegado
    if (!/^\d+$/.test(pastedText)) {
      e.preventDefault();
    }
  };
  //Función para obtener departamentos y municipios
  const obtenerdepartamentos = useCallback(async () => {
    try {
      setDepartamentos([]);
      form.setFieldsValue({ departamento: [] });
      setMunicipioSeleccionado(null);
      const { data } = await cargarDeptosMunicipios();
      setDepartamentosxmunicipio(data);

      let uniqueDepartamentos = data.map((departamento) => ({
        id: departamento.oid_departamento,
        nombre: departamento.nombre_departamento,
      }));

      setDepartamentos(uniqueDepartamentos);
    } catch (error) {
      console.error("Error al obtener departamentos:", error);
    }
  }, [form]);

  //Función para obtener todos las organizaciones
  const obtenerOrganizaciones = useCallback(async () => {
    try {
      setOrganizaciones([]);
      form.setFieldsValue({ id_organizacion: [] });
      const result = await getAllOrganizacionesSostenibilidad();
      if (result.status) {
        setOrganizaciones(result.organizaciones);
      } else {
        setOrganizaciones([]);
      }
    } catch (error) {
      setOrganizaciones([]);
    }
  }, [form]);

  //Función para obtener enfoques de etnia
  const obtenerEnfoqueEtnia = useCallback(async () => {
    try {
      setEnfoquesEtnia([]);
      form.setFieldsValue({ id_enfoque_etnico: [] });
      const result = await getAllEnfoqueEtnia();
      if (result.status) {
        setEnfoquesEtnia(result.enfoques);
      } else {
        setEnfoquesEtnia([]);
      }
    } catch (error) {
      setEnfoquesEtnia([]);
    }
  }, [form]);

  //Función para obtener todos los proyectos por una organización
  const obtenerProyectosxOrganizacion = useCallback(
    async (id_organizacion) => {
      try {
        setProyectosxOrganizacion([]);
        form.setFieldsValue({ id_proyecto: [] });
        const result = await getAllProyectosxOrganizacionesSostenibilidad(
          id_organizacion
        );
        if (result.status) {
          setProyectosxOrganizacion(result.proyectos);
        } else {
          setProyectosxOrganizacion([]);
        }
      } catch (error) {
        setProyectosxOrganizacion([]);
      }
    },
    [form]
  );

  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item label="Código SIRR" name="codigo_sirr">
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            label="Nombre Completo"
            name="nombre_completo"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            label="N. identificación"
            name="identificacion"
            rules={[
              { required: true, message: "Este campo es requerido" },
              {
                pattern: /^\d+$/,
                message: "Solo se permiten números positivos",
              },
            ]}
          >
            <Input
              type="text" // Usamos "text" para tener más control (evitar validación por defecto del navegador)
              onKeyDown={handleKeyDown}
              onPaste={handlePaste}
              onChange={(e) => {
                // Filtramos cualquier carácter no numérico (por si acaso)
                const value = e.target.value.replace(/[^\d]/g, "");
                form.setFieldsValue({ identificacion: value });
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            label="Edad"
            name="edad"
            rules={[
              { required: true, message: "La edad es requerida" },
              {
                validator: (_, value) =>
                  value > 0
                    ? Promise.resolve()
                    : Promise.reject("La edad debe ser mayor a 0"),
              },
            ]}
          >
            <Input
              type="text" // Usamos "text" para mayor control
              onKeyDown={handleKeyDown}
              onPaste={handlePaste}
              onChange={(e) => {
                // Filtra cualquier carácter no numérico
                const value = e.target.value.replace(/[^\d]/g, "");
                form.setFieldsValue({ edad: value });
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item label="Género" name="genero" rules={[{ required: true }]}>
            <Select placeholder="Seleccione">
              <Option value="MASCULINO">MASCULINO</Option>
              <Option value="FEMENINO">FEMENINO</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            label="Enfoque Étnico"
            name="id_enfoque_etnico"
            rules={[{ required: true }]}
          >
            <Select placeholder="Seleccione Enfoque Étnico">
              {enfoquesEtnia.map((enf) => (
                <Option key={enf.oid} value={enf.oid}>
                  {enf.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        {/* Discapacidad - Radio Sí/No */}
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            label="Discapacidad"
            name="discapacidad"
            rules={[{ required: true, message: "Seleccione una opción" }]}
          >
            <Radio.Group
              onChange={(e) => {
                setTieneDiscapacidad(e.target.value);
                if (e.target.value === "No") {
                  form.setFieldsValue({
                    discapacidad: "No",
                    discapacidadOtro: undefined,
                    tipo_discapacidad: "No aplica",
                  });
                  setMostrarInputOtro(false);
                } else {
                  form.setFieldsValue({
                    tipo_discapacidad: undefined,
                  });
                }
              }}
            >
              <Radio value="Sí">Sí</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        {/* Tipo de Discapacidad (condicional) */}
        {tieneDiscapacidad && (
          <>
            <Col xs={24} sm={12} md={12} lg={8}>
              <Form.Item
                label="Tipo discapacidad"
                name="tipo_discapacidad"
                rules={[
                  {
                    required: tieneDiscapacidad,
                    message: "Seleccione o especifique",
                  },
                ]}
              >
                <Select
                  disabled={tieneDiscapacidad === "No"}
                  placeholder="Seleccione..."
                  options={[...tiposDiscapacidad]}
                  onChange={(value) => {
                    setMostrarInputOtro(value === "Otro");
                    if (value !== "Otro") {
                      form.setFieldValue("discapacidadOtro", undefined);
                    }
                  }}
                />
              </Form.Item>
            </Col>

            {/* Campo para "Otro" (condicional) */}
            {mostrarInputOtro && (
              <Col xs={24} sm={12} md={12} lg={8}>
                <Form.Item
                  name="discapacidadOtro"
                  label="Otra discapacidad"
                  rules={[
                    {
                      required: mostrarInputOtro,
                      message: "Especifique la discapacidad",
                    },
                  ]}
                >
                  <Space.Compact style={{ width: "100%" }}>
                    <Input placeholder="Especifique..." allowClear />
                  </Space.Compact>
                </Form.Item>
              </Col>
            )}
          </>
        )}
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6} lg={6}>
          <Form.Item
            label="Departamento"
            name="departamento"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Seleccione Departamento"
              onChange={handleDepartamentoChange}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {departamentos.map((depto) => (
                <Option key={depto.id} value={depto.nombre}>
                  {depto.nombre}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6} lg={6}>
          <Form.Item
            label="Municipio"
            name="id_municipio"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              placeholder="Seleccione Municipio"
              disabled={!departamentoSeleccionado}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {Array.isArray(municipios) && municipios.length > 0 ? (
                municipios.map((mun) => (
                  <Option key={mun.id} value={mun.id}>
                    {mun.nombre}
                  </Option>
                ))
              ) : (
                <Option disabled value="">
                  No hay municipios disponibles
                </Option>
              )}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6} lg={6}>
          <Form.Item
            label="Firmante"
            name="firmante"
            rules={[{ required: true, message: "Seleccione una opción" }]}
          >
            <Radio.Group>
              <Radio value="SI">SI</Radio>
              <Radio value="NO">NO</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6} lg={6}>
          <Form.Item
            label="Tipo participante"
            name="tipo_participante"
            rules={[{ required: true, message: "Seleccione una opción" }]}
          >
            <Radio.Group
              onChange={(e) => {
                setTipoParticipante(e.target.value);
                if (e.target.value === "Invitado") {
                  form.setFieldsValue({
                    id_organizacion: "Invitado a capacitación",
                  });
                } else {
                  if (initialData?.id_organizacion) {
                    setOrganizacionSeleccionada(initialData.id_organizacion);
                    form.setFieldsValue({
                      id_organizacion: initialData.id_organizacion,
                    });
                  } else {
                    form.setFieldsValue({
                      id_organizacion: undefined,
                    });
                  }

                  if (initialData?.id_proyecto) {
                    setProyectoSeleccionado(initialData.id_proyecto);

                    form.setFieldsValue({
                      id_proyecto: initialData.id_proyecto,
                    });
                  } else {
                    form.setFieldsValue({
                      id_proyecto: undefined,
                    });
                  }
                }
              }}
              value={tipoParticipante}
            >
              <Radio value="Asociado">Asociado</Radio>
              <Radio value="Invitado">Invitado</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        {tipoParticipante && (
          <>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                label="Organización"
                name="id_organizacion"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  placeholder="Seleccione Organización"
                  optionFilterProp="children"
                  value={organizacionSeleccionada}
                  onChange={handleOrganizacionChange}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  disabled={
                    initialData?.id_organizacion ||
                    tipoParticipante === "Invitado"
                  }
                >
                  {organizaciones.map((org) => (
                    <Option key={org.id} value={org.id}>
                      {org.sigla}
                    </Option>
                  ))}
                  <Option
                    key="Invitado a capacitación"
                    value="Invitado a capacitación"
                  >
                    Invitado a capacitación
                  </Option>
                </Select>
              </Form.Item>
            </Col>

            {tipoParticipante == "Asociado" && (
              <Col xs={24} sm={12} md={12} lg={12}>
                <Form.Item
                  label="Proyecto"
                  name="id_proyecto"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    placeholder="Seleccione Proyecto"
                    disabled={
                      !organizacionSeleccionada || initialData?.id_proyecto
                    }
                    value={proyectoSeleccionado}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {proyectosxOrganizacion.map((p) => (
                      <Option key={p.id_proyecto} value={p.id_proyecto}>
                        {p.nombre_proyecto}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}
          </>
        )}
      </Row>

      <Form.Item style={{ display: "flex", justifyContent: "center" }}>
        <Flex gap="small" wrap justify="center">
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            style={{
              backgroundColor: "#52C41A",
              color: "#fff",
              textAlign: "center",
            }}
          >
            Guardar registro
          </Button>
        </Flex>
      </Form.Item>
    </Form>
  );
};

export default ParticipanteForm;
